export default __webpack_public_path__ + "static/GuildLogoFinalBug-76c7701cc89e95d253eb89ceceafe5cc.png";